// extracted by mini-css-extract-plugin
module.exports = {"resetBtn":"_12Wl-2wIbi8bwKUdmK7CFN","icon":"_32cufg7wojnorIXU5CdJ_p","active":"_17-nwE5SpcayztggiCHG3I"};